import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

function AgeGate() {
  const [showGate, setShowGate] = useState(() => {
    return !localStorage.getItem('tilted-age-verified');
  });

  const handleVerify = () => {
    localStorage.setItem('tilted-age-verified', 'true');
    setShowGate(false);
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!showGate) return null;

  return (
    <div className="fixed inset-0 bg-dive-black z-[9999] flex flex-col items-center justify-start p-4 pt-16 overflow-y-auto">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <img 
          src="/logo-full.png" 
          alt="Tilted" 
          className="w-[260px] max-w-[70vw] mx-auto mb-4"
        />
        <p className="text-gray-400 mb-8">
          The Dive Bar Community App
        </p>

        {/* Age Warning */}
        <div className="bg-dive-dark border border-dive-gray rounded-2xl p-6 mb-6">
          <div className="flex items-center justify-center gap-3 text-amber-400 mb-4">
            <AlertTriangle className="w-6 h-6" />
            <span className="font-bold text-lg">Age Verification Required</span>
          </div>
          
          <p className="text-gray-300 mb-6">
            This website contains content related to alcohol consumption. 
            You must be at least <strong className="text-white">21 years of age</strong> to enter.
          </p>

          <div className="space-y-3">
            <button
              onClick={handleVerify}
              className="btn-primary w-full py-4 text-lg"
            >
              I am 21 or older
            </button>
            
            <button
              onClick={handleExit}
              className="btn-secondary w-full py-3"
            >
              Exit
            </button>
          </div>
        </div>

        <p className="text-gray-600 text-xs">
          By entering, you confirm that you are of legal drinking age in your jurisdiction.
          Please drink responsibly.
        </p>
      </div>
    </div>
  );
}

export default AgeGate;

